import React from "react";
import { Paper, Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    height: "100%",
  },
  title: { fontWeight: 600 },
  subtitle: { color: theme.palette.text.secondary, marginBottom: theme.spacing(1.5) },
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    alignItems: "center",
    columnGap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
  },
  name: {
    fontSize: "0.82rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  value: {
    fontSize: "0.82rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  track: {
    gridColumn: "1 / -1",
    height: 6,
    borderRadius: 4,
    backgroundColor: theme.palette.action.hover,
    overflow: "hidden",
    marginTop: 4,
  },
  bar: {
    height: "100%",
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
  empty: {
    color: theme.palette.text.secondary,
    fontSize: "0.82rem",
    textAlign: "center",
    padding: theme.spacing(2),
  },
}));

/** Lista de barras horizontais com nome e valor (ex.: conversas por fila). */
export default function BreakdownList({ title, subtitle, items = [], loading, emptyText }) {
  const classes = useStyles();
  const max = Math.max(1, ...items.map((i) => i.total));
  const sum = items.reduce((s, i) => s + i.total, 0);

  return (
    <Paper className={classes.root}>
      <Typography variant="subtitle1" className={classes.title}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" component="div" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
      {loading ? (
        <Skeleton variant="rect" height={120} style={{ borderRadius: 8 }} />
      ) : items.length === 0 ? (
        <div className={classes.empty}>{emptyText || "Sem dados no período"}</div>
      ) : (
        items.slice(0, 8).map((item) => {
          const pct = sum ? Math.round((item.total / sum) * 100) : 0;
          return (
            <Tooltip
              key={item.id ?? item.name}
              title={`${item.name}: ${item.total} (${pct}%)`}
              placement="top-start"
            >
              <div className={classes.row}>
                <span className={classes.name}>{item.name}</span>
                <span className={classes.value}>{item.total.toLocaleString("pt-BR")}</span>
                <div className={classes.track}>
                  <div
                    className={classes.bar}
                    style={{
                      width: `${(item.total / max) * 100}%`,
                      backgroundColor: item.color || undefined,
                    }}
                  />
                </div>
              </div>
            </Tooltip>
          );
        })
      )}
    </Paper>
  );
}
